import React from "react";
import { format } from "date-fns";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface EmailBarChartProps {
  data: any[];
  title: string;
  description?: string;
  className?: string;
}

export function EmailBarChart({ data, title, description, className }: EmailBarChartProps) {
  const formatDate = (dateString: string) => {
    return format(new Date(dateString), "MMM d");
  };

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="date" 
                tickFormatter={formatDate} 
                className="text-xs text-muted-foreground"
              />
              <YAxis className="text-xs text-muted-foreground" />
              <Tooltip
                contentStyle={{ 
                  backgroundColor: "hsl(var(--background))",
                  borderColor: "hsl(var(--border))",
                  borderRadius: "var(--radius)",
                  boxShadow: "var(--shadow)"
                }}
                labelFormatter={(label) => formatDate(label)}
                formatter={(value) => [value, ""]}
              />
              <Legend />
              <Bar 
                dataKey="bounced" 
                fill="hsl(var(--destructive))" 
                radius={[4, 4, 0, 0]}
                name="Bounced" 
              />
              <Bar 
                dataKey="complained" 
                fill="hsl(var(--warning))" 
                radius={[4, 4, 0, 0]}
                name="Complained" 
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
